export const ADMIN_FETCH_CONSTITUENT_SUBSCRIPTIONS = "ADMIN_FETCH_CONSTITUENT_SUBSCRIPTIONS"
export const ADMIN_RECEIVE_CONSTITUENT_SUBSCRIPTIONS = "ADMIN_RECEIVE_CONSTITUENT_SUBSCRIPTIONS"
export const DOWNLOAD_EMAIL_DATA = "DOWNLOAD_EMAIL_DATA"

export const adminReceiveConstituentSubscriptions = (subscriptions) => ({
  type: ADMIN_RECEIVE_CONSTITUENT_SUBSCRIPTIONS,
  subscriptions,
})

export const adminFetchConstituentSubscriptions = (constituentId, success) => ({
  type: ADMIN_FETCH_CONSTITUENT_SUBSCRIPTIONS,
  constituentId,
  success,
})

export const downloadEmailData = (success, error) => ({
  type: DOWNLOAD_EMAIL_DATA,
  success,
  error,
})
